import PermissionsBtn from '@/components/PermissionsBtn';

export default (Vue) => {
    Vue.component("PermissionsBtn", PermissionsBtn)
}